import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=e10e7b30&scoped=true&"
import script from "./BackToTop.vue?vue&type=script&lang=ts&"
export * from "./BackToTop.vue?vue&type=script&lang=ts&"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=e10e7b30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10e7b30",
  null
  
)

export default component.exports